import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener en cuenta que estas no son tareas para reparaciones correctivas o para planes de mantenimiento. Son tareas que se utilizarán para la carga del registro de engrases, recargas de aceite, y cualquier tarea de mantenimiento diario en campo.',
  ],
  tips: [
    'Las tareas de lubricación se usan en los registros de engrase y aceite diarios.',
    'No definas tareas de recarga de combustible. Existe un módulo específico para eso.',
  ],
  nextSteps: [
    'Registrar engrases y recargas de aceite en los equipos desde el módulo de Lubricación.',
    'Consultá el informe de tareas y consumos de lubricantes para ver el detalle de los trabajos realizados y los consumos de lubricantes por equipo y período.',
  ],
};

const ConfiguracionTareasEngrase = () => (
  <ConfiguracionBase
    apiEndpoint="tareasengrase"
    titulo="Tareas de Lubricación"
    descripcion="Tareas de lubricación (engrase, recargas de fluidos y control de niveles)"
    icon="fas fa-oil-can"
    compact
    help={HELP}
  />
);

export default ConfiguracionTareasEngrase;
  